<script setup lang="ts">
const props = defineProps<{
  inflectionSchemeHtml: string | null | undefined;
}>();
</script>

<template>
  <div class="le-legacy-inflection-scheme">
    <div v-html="props.inflectionSchemeHtml"></div>
  </div>
</template>

<style lang="less" scoped>
.le-legacy-inflection-scheme {
  ::v-deep(.schema-container) {
    margin-top: 0;
    margin-bottom: 0;
  }

  ::v-deep(.schema-close-btn) {
    display: none;
  }
}
</style>
